import { render, staticRenderFns } from "./messageService.vue?vue&type=template&id=80a231c2&scoped=true"
import script from "./messageService.vue?vue&type=script&lang=js"
export * from "./messageService.vue?vue&type=script&lang=js"
import style0 from "./messageService.vue?vue&type=style&index=0&id=80a231c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a231c2",
  null
  
)

export default component.exports